import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { z } from "zod";

export type RecipientNameJSON = z.infer<typeof RecipientNameSchema.RecipientNameJSONZ>;
export type RecipientNameParams = z.infer<typeof RecipientNameSchema.RecipientNameZ>;

export default class RecipientNameSchema {
  public static readonly RecipientNameJSONZ = z.string().min(1);
  public static readonly RecipientNameZ = z.string().min(1);

  public static readonly codec = z.codec(RecipientNameSchema.RecipientNameJSONZ, RecipientNameSchema.RecipientNameZ, {
    decode: (recipientNameJSON) => recipientNameJSON,
    encode: (recipientNameValue) => recipientNameValue,
  });

  public static validate(value: unknown): RecipientNameParams {
    return parseOrThrow(RecipientNameSchema.RecipientNameZ, value, {
      logError: true,
      schemaName: "RecipientNameParams",
      operation: "validate",
      payloadSample: value,
    });
  }

  public static validateJSON(values: unknown): RecipientNameJSON {
    return parseOrThrow(RecipientNameSchema.RecipientNameJSONZ, values, {
      logError: true,
      schemaName: "RecipientNameParams",
      operation: "validateJSON",
      payloadSample: values,
    });
  }

  public static isValidJSON(values: unknown): values is RecipientNameJSON {
    try {
      RecipientNameSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: unknown): RecipientNameParams {
    const parsed = RecipientNameSchema.validateJSON(data);
    return RecipientNameSchema.codec.decode(parsed);
  }

  public static serialize(data: RecipientNameParams): RecipientNameJSON {
    const parsed = RecipientNameSchema.validate(data);
    return RecipientNameSchema.codec.encode(parsed);
  }
}
